import React from "react";
import { withStyles } from "@material-ui/core/styles";
import AddCircleOutlined from "@material-ui/icons/Loupe";
import ToolTip from "../../../../../common/StyledToolTip";
import styles from "./styles";

const Message = ({ classes, onClick, isDisabled = false }) => (
  <div
    className={
      isDisabled ? classes.scDisabledHeaderMsgIcon : classes.scHeaderCloseButton
    }
  >
    <ToolTip title={isDisabled ? "Not allowed" : "Multiple choice questions"}>
      <AddCircleOutlined
        className={
          isDisabled ? classes.scDisabledHeaderMsgIcon : classes.scHeaderMsgIcon
        }
        onClick={isDisabled ? null : onClick}
      ></AddCircleOutlined>
    </ToolTip>
  </div>
);

export default withStyles(styles)(Message);
